import {
  EAuditResultType,
} from '@/types/audit-result.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const sectionResult: Record<TComponentValue<'AuditResultType'>, string> = {
  [EAuditResultType.PASSED]: 'In Band',
  [EAuditResultType.INCONCLUSIVE]: 'Inconclusive',
  [EAuditResultType.FAILED]: 'Out of Band',
};

export default {
  timeIn: 'Time in',
  timeOut: 'Time out',
  valueAtStart: 'Value at start',
  valueRange: 'Value range',
  mainTemp: 'Main Temp',
  medianValue: 'Median value',
  timeInBand: 'Time in band',
  sectionResult,
};
